import { Component, inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss',
    standalone: false
})
export class AccessDeniedComponent {
  private keycloakService = inject(KeycloakService);

  onLogout() {
    this.keycloakService.logout(window.location.origin);
  }
}

